import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';


@Injectable()
export class StatsService extends AuthService{

    private URLGetHoursWeek = "api/v1/getHoursWeek";
    private URLGetHoursMonth = "api/v1/getHoursMonth";
    constructor(public http: Http, public router: Router) { 
        super(http,router)
    }

    public getHoursWeek() {
        return this.http.get(this.APIURL + this.URLGetHoursWeek ,{headers: this.headers})
        .map((res: Response) => res.json())
        .filter( data => {
            var actualWeek = moment().week();
            var nextWeek = actualWeek + 1;
            data["actualWeek"] = "S" + actualWeek;
            data["nextWeek"] = "S" + nextWeek;
            return true;
        }); 
    }

    public getHoursMonth() {
        moment.locale("es");
        return this.http.get(this.APIURL + this.URLGetHoursMonth, {headers: this.headers})
        .map((res: Response) => res.json())
        .filter( data => {
            var month = moment().format("MMMM");
            var nextMonth = moment().add(1,"M").format("MMMM");

            month = month.substring(0,3);
            month = month.charAt(0).toUpperCase() + month.slice(1);
            nextMonth = nextMonth.substring(0,3);
            nextMonth = nextMonth.charAt(0).toUpperCase() + nextMonth.slice(1);
            data["actualMonth"] = month;
            data["nextMonth"] = nextMonth;
            return true;
        }); 
    }

}


// WEBPACK FOOTER //
// ./src/app/injections/stats.service.ts